import {useEffect, useRef, useState} from "react";

export default function Card ({ name, illustration, description }) {
    const canvasRef = useRef(null);
    const [ baseImage, setBaseImage ] = useState(null);

    useEffect(() => {
        const img = new Image();
        img.onload = () => setBaseImage(img);
        img.src = "/bases/exploration.png";
    }, [])

    useEffect(() => {
        const canvas = canvasRef.current;

        canvas.width = 773;
        canvas.height = 1080;
    }, [canvasRef])

    const prepareCanvas = (ctx) => {
        ctx.width = canvasRef.current.width;
        ctx.height = canvasRef.current.height;
        ctx.clearRect(0, 0, ctx.width, ctx.height)
        ctx.fillStyle = 'black';
        ctx.beginPath();
        //ctx.rect(80, 100, 615, 600);
        ctx.fill()
    }

    const drawIllustration = (ctx, illustration) => {
        return new Promise((resolve, reject) => {
            if (illustration === undefined || illustration == null) {
                resolve();
            }
            const url = URL.createObjectURL(illustration);
            const img = new Image();
            img.width = 615;
            img.height = 600;
            img.onload = function() {
                ctx.drawImage(img, 80, 100, 615, 600);
                resolve();
            }
            img.onerror = (e) => reject(e);
            img.src = url;
        })
    }

    const drawCardName = (ctx, name) => {
        ctx.fillStyle = 'white';
        ctx.font = 'bold 30px itc';
        const nameSize = ctx.measureText(name).width
        ctx.fillText(name, ctx.width / 2 - nameSize / 2, 622);
    }

    const drawSerial = (ctx) => {
        ctx.fillStyle = '#5f6160';
        ctx.font = 'bold 12px sans-serif';
        const angle = 90
        const id = Math.round(Math.random() * 100000)
        ctx.rotate((angle * Math.PI / 180));
        ctx.fillText(`HE-${id}-FUN`, 920, -720);
        ctx.rotate((-angle * Math.PI / 180));
    }

    const drawDescription = (ctx, text, y, maxWidth) => {
        ctx.fillStyle = 'white';
        ctx.font = '17px sans-serif';
        const words = text.split(' ');
        let line = '"';

        for (let i = 0; i < words.length; i++) {
            let currentLine = line + words[i];
            if (i === words.length - 1) {
                currentLine += '"';
            } else {
                currentLine += ' '
            }
            const lineWidth = ctx.measureText(currentLine).width;

            if (lineWidth > maxWidth && i > 0) {
                ctx.fillText(line, ctx.width / 2 - ctx.measureText(line).width / 2, y);
                line = words[i] + ' ';
                y += 25;
            } else {
                line = currentLine;
            }
        }
        const lineWidth = ctx.measureText(line).width;
        ctx.fillText(line, ctx.width / 2 - lineWidth / 2, y);
    }

    if (canvasRef !== undefined && baseImage != null) {
        const ctx = canvasRef.current.getContext('2d');

        prepareCanvas(ctx);
        drawIllustration(ctx, illustration).then(() => {
            ctx.drawImage(baseImage, 0, 0);
            drawCardName(ctx, name);
            drawSerial(ctx)
            drawDescription(ctx, description, 870, 500, 20);
        });
    }

    return <div className={ "h-full"}>
        <canvas ref={canvasRef} className="h-full rounded-xl" ></canvas>
    </div>
}